import { useState } from "react";
import TopBar from "./components/TopBar";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import LiveTickerSection from "./components/LiveTickerSection";
import ProblemSection from "./components/ProblemSection";
import SolutionSection from "./components/SolutionSection";
import StatsSection from "./components/StatsSection";
import BuiltForTitleSection from "./components/BuiltForTitleSection";
import ProofSection from "./components/ProofSection";
import PricingSection from "./components/PricingSection";
import ROISection from "./components/ROISection";
import HowItWorksSection from "./components/HowItWorksSection";
import TerritorySection from "./components/TerritorySection";
import AboutSection from "./components/AboutSection";
import FAQSection from "./components/FAQSection";
import FinalCTASection from "./components/FinalCTASection";
import Footer from "./components/Footer";
import FormModal from "./components/FormModal";

type ModalType = "market" | "territory" | null;

export default function Home() {
  const [modalType, setModalType] = useState<ModalType>(null);

  const openMarket = () => setModalType("market");
  const openTerritory = () => setModalType("territory");
  const closeModal = () => setModalType(null);

  return (
    <div className="min-h-screen bg-white font-sans">
      {/* Announcement bar */}
      <TopBar />

      {/* Navigation */}
      <Navbar onCTAClick={openMarket} />

      {/* Main content */}
      <main>
        <HeroSection onPrimaryCTA={openMarket} />
        <LiveTickerSection />
        <ProblemSection />
        <SolutionSection />
        <StatsSection />
        <BuiltForTitleSection />
        <ProofSection />
        <PricingSection onCTAClick={openMarket} />
        <ROISection onCTAClick={openMarket} />
        <HowItWorksSection />
        <TerritorySection onCTAClick={openTerritory} />
        <AboutSection />
        <FAQSection />
        <FinalCTASection onMarketCTA={openMarket} onTerritoryCTA={openTerritory} />
      </main>

      <Footer />

      {/* Modals */}
      <FormModal
        isOpen={modalType === "market"}
        onClose={closeModal}
        type="market"
      />
      <FormModal
        isOpen={modalType === "territory"}
        onClose={closeModal}
        type="territory"
      />
    </div>
  );
}
